import { RETAIL_BASE_ROUTE } from 'config/retail/routes';

export const RETAIL_RESIDENTIAL_CUSTOMER_INFORMATION_ROUTE = `${RETAIL_BASE_ROUTE}/home/customer-information`;
export const RETAIL_RESIDENTIAL_UTILITY_ACCOUNT_INFORMATION_ROUTE = `${RETAIL_BASE_ROUTE}/home/utility-account-information`;
export const RETAIL_RESIDENTIAL_FLOW_CONFIRMATION_ROUTE = `${RETAIL_BASE_ROUTE}/home/confirmation`;
export const RETAIL_RESIDENTIAL_SUCCESS_ROUTE = `${RETAIL_BASE_ROUTE}/home/success`;
